var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2182_21157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58724 0.882911L1.94571 0.504883C0.871107 0.504883 0 1.37603 0 2.4506C0 2.58034 0.0127163 2.7071 0.0369014 2.82975C0.103863 3.16871 0.405875 3.41015 0.751388 3.41015H5.55429L4.58724 0.882911Z",
    fill: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94568 0.504883C3.02025 0.504883 3.89139 1.37599 3.89139 2.4506V17.5496C3.89139 18.6242 4.7625 19.4953 5.83711 19.4953L16.9161 17.5496V2.4506C16.9161 1.37603 16.045 0.504883 14.9703 0.504883H1.94568Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83716 19.4948V19.1846L6.41249 19.1143L6.60601 19.431L6.06907 19.4886L5.897 19.4948H5.83716Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3961 17.4964C18.3826 16.9911 17.9659 16.5898 17.4604 16.5898H8.71414C8.19277 16.5898 7.7801 17.0176 7.78283 17.5389C7.78287 17.5424 7.78287 17.5459 7.78287 17.5494C7.78287 18.624 6.91177 19.4951 5.83716 19.4951H16.4162C17.4995 19.4951 18.4097 18.6087 18.3966 17.5255C18.3965 17.5158 18.3963 17.5061 18.3961 17.4964Z",
    fill: "#DEDEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9411 7.6378H7.12127C6.95455 7.6378 6.81946 7.50267 6.81946 7.33599C6.81946 7.16931 6.95455 7.03418 7.12127 7.03418H14.9411C15.1078 7.03418 15.2429 7.16931 15.2429 7.33599C15.2429 7.50267 15.1078 7.6378 14.9411 7.6378Z",
    fill: "#6A647F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9411 9.49718H7.12127C6.95455 9.49718 6.81946 9.36205 6.81946 9.19537C6.81946 9.02869 6.95455 8.89355 7.12127 8.89355H14.9411C15.1078 8.89355 15.2429 9.02869 15.2429 9.19537C15.2429 9.36205 15.1078 9.49718 14.9411 9.49718Z",
    fill: "#6A647F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9411 11.3585H7.12127C6.95455 11.3585 6.81946 11.2234 6.81946 11.0567C6.81946 10.89 6.95455 10.7549 7.12127 10.7549H14.9411C15.1078 10.7549 15.2429 10.89 15.2429 11.0567C15.2429 11.2234 15.1078 11.3585 14.9411 11.3585Z",
    fill: "#6A647F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1552 4.73119C17.6968 4.96789 16.1109 5.7905 14.7747 7.12664C13.1555 8.74583 12.2905 10.7318 12.3084 12.4132C13.9898 12.4312 15.9758 11.5662 17.595 9.94692C18.9311 8.61078 19.7537 7.02487 19.9904 5.56644C20.0696 5.07875 19.6429 4.65207 19.1552 4.73119Z",
    fill: "#E4996D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0782 13.9456C11.001 13.9456 10.9237 13.9162 10.8648 13.8572C10.7469 13.7393 10.7469 13.5482 10.8648 13.4304L17.5036 6.79153C17.6215 6.67366 17.8126 6.67366 17.9304 6.79153C18.0483 6.90939 18.0483 7.1005 17.9304 7.21837L11.2916 13.8572C11.2327 13.9162 11.1554 13.9456 11.0782 13.9456Z",
    fill: "#D97C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10843 14.5538H7.12127C6.95455 14.5538 6.81946 14.4187 6.81946 14.252C6.81946 14.0853 6.95455 13.9502 7.12127 13.9502H9.10843C9.27515 13.9502 9.41024 14.0853 9.41024 14.252C9.41024 14.4187 9.27511 14.5538 9.10843 14.5538Z",
    fill: "#6A647F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2182_21157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoring);
export default __webpack_public_path__ + "static/media/scoring.a59900ce456354fec0db213d37f737ae.svg";
export { ForwardRef as ReactComponent };